module.exports = __webpack_public_path__ + "static/media/r4s2.7768d604.jpg";